import {mergeViewStateForFulfillment} from "../../../Cob.helpers";

export default function (state, prevState)
{
	if (import.meta.env.VITE_CHECK_VIEW_FULFILLMENT === "0")
	{
		return true;
	}

	state = mergeViewStateForFulfillment(state, prevState);
	const {customerState} = state;
	const {isCompany} = customerState;

	if (isCompany)
	{
		// Historiskt resultat
		if (customerState.customer_comp_histresult1.length <= 0 ||
			customerState.customer_comp_histresult2.length <= 0 ||
			customerState.customer_comp_histresult3.length <= 0)
		{
			return false;
		}

		// Uppskattat resultat
		if (customerState.customer_comp_budresult12m.length <= 0 ||
			customerState.customer_comp_budresult24m.length <= 0)
		{
			return false;
		}

		// Tillgångar
		if (customerState.customer_comp_assets_cash.length <= 0 ||
			customerState.customer_comp_assets_fininstr.length <= 0 ||
			customerState.customer_comp_assets_other.length <= 0)
		{
			return false;
		}

		return true;
	}

	// Civilstånd
	if (customerState.maritalStatus.length <= 0)
	{
		return false;
	}

	// Antal barn samt deras personinfo
	if (customerState.customer_child_no.length <= 0)
	{
		return false;
	}

	// Månadsinkomst före skatt måste fyllas i
	if (customerState.salary.length <= 0)
	{
		return false;
	}

	if (customerState.customer_monthly_savings.length <= 0)
	{
		return false;
	}

	if (!customerState.radio_customer_plans_exit || customerState.radio_customer_plans_exit.length <= 0)
	{
		return false;
	}

	if (customerState.radio_customer_plans_exit === "yes")
	{
		if (customerState.customer_plans_exit_when.length <= 0)
		{
			return false;
		}
	}

	return true;
}